import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Leftpanel from "../../layout/Leftpanel";
import { getAllIndustryDetailslist } from "../../../../service/BusinessUnit/BusinessUnitService";
import { getIndustryById } from "../../../../service/Department/DepartmentService";
import { getALLGLlist } from "../../../../service/gl/glService";
import {
  AddAccountingDimensions,
  listAccountingDimensions,
  DeleteAccountingDimensions,
  addEditAccountDimension,
  getAccountDimensionById,
  getAccountDimensionSingle,
} from "../../../../service/AccountingDimensions/AccountingDimensions";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EditAccountingDimensions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [allData, setAllData] = useState();
  const [id, setId] = useState();
  const [accountingDimensions, setAccountingDimensions] = useState({
    dimension2: "",
    dimension3: "",
    dimension4: "",
    dimension5: "",
    dimension6: "",
  });
  const [accountingDimensionsFieldName, setAccountingDimensionsFieldName] =
    useState({
      GLFieldName: "",
      Dimension2FieldName: "",
      Dimension3FieldName: "",
      Dimension4FieldName: "",
      Dimension5FieldName: "",
      Dimension6FieldName: "",
    });
  const [glKey, setGlKey] = useState(null);
  const [totalDimantion, setTotalDimantion] = useState(6);
  const _FETCH_GL_KEY = async () => {
    getALLGLlist()
      .then((res) => {
        setGlKey({
          text: res?.data?.data?.glList[0]?.value,
          key: res?.data?.data?.glList[0]?.key,
          id: res?.data?.data?.glList[0]?.id,
        });
      })
      .catch((err) => {
      //  console.log(err);
      });
  };

  const _GET_ACCOUTING_DIMANTION_BY_ID = () => {
    // console.log(searchParams.get("id"),"dimantionId")
    getAccountDimensionSingle(id, (res) => {
      setAllData(res?.data?.info);
      setGlKey({
        text: res?.data?.info?.GL?.value,
        key: res?.data?.info?.GL?.key,
        id: res?.data?.info?.GL?.id,
      });
      setAccountingDimensions({
        dimension2: res?.data?.info?.dimension2
          ? res?.data?.info?.dimension2
          : "",
        dimension3: res?.data?.info?.dimension3
          ? res?.data?.info?.dimension3
          : "",
        dimension4: res?.data?.info?.dimension4
          ? res?.data?.info?.dimension4
          : "",
        dimension5: res?.data?.info?.dimension5
          ? res?.data?.info?.dimension5
          : "",
        dimension6: res?.data?.info?.dimension6
          ? res?.data?.info?.dimension6
          : "",
      });
      setAccountingDimensionsFieldName({
        GLFieldName: res?.data?.info?.GLFieldName
          ? res?.data?.info?.GLFieldName
          : "",
        Dimension2FieldName: res?.data?.info?.Dimension2FieldName
          ? res?.data?.info?.Dimension2FieldName
          : "",
        Dimension3FieldName: res?.data?.info?.Dimension3FieldName
          ? res?.data?.info?.Dimension3FieldName
          : "",
        Dimension4FieldName: res?.data?.info?.Dimension4FieldName
          ? res?.data?.info?.Dimension4FieldName
          : "",
        Dimension5FieldName: res?.data?.info?.Dimension5FieldName
          ? res?.data?.info?.Dimension5FieldName
          : "",
        Dimension6FieldName: res?.data?.info?.Dimension6FieldName
          ? res?.data?.info?.Dimension6FieldName
          : "",
      });

      //   if(res?.data?.info?.dimension2===''){
      //     setTotalDimantion(2)
      //      return;
      //   }else if(res?.data?.info?.dimension3===''){
      //     setTotalDimantion(3)
      //     return;
      //   }else if(res?.data?.info?.dimension4===''){
      //     setTotalDimantion(4)
      //     return;
      //   }else if(res?.data?.info?.dimension5===''){
      //     setTotalDimantion(5)
      //     return;
      //   }else if(res?.data?.info?.dimension6===''){
      //     setTotalDimantion(6)
      //     return;
      //   }
    });
  };

  useEffect(() => {
    // _FETCH_BUSINESS_UNIT();
    _FETCH_ACCOUNTING_DIMENSION();
    _FETCH_GL_KEY();

    // _FETCH_ACCOUTING_DIMENSION_BY_ID();
  }, []);

  useEffect(() => {
    if (id) {
      _GET_ACCOUTING_DIMANTION_BY_ID();
    }
  }, [id]);

  const _FETCH_ACCOUNTING_DIMENSION = async () => {
    getAccountDimensionById((res) => {
      setId(res?.data?.infoList[0]?.id);
    });
  };

  const _UPDATE_DIMANTION = async (data) => {
    setTotalDimantion(data);
  };
//  console.log("accountingDimensionsFieldName", accountingDimensionsFieldName);
  const _ADD_GL_KEY = async (e) => {
    e.preventDefault();
    try {
      let data = {};
      if (totalDimantion == 6) {
        // if (accountingDimensions?.dimension2 === "") {
        //   toast.error(`Please enter accouting dimension 2`);
        //   return;
        // } else if (accountingDimensions?.dimension3 === "") {
        //   toast.error(`Please enter accouting dimension 3`);
        //   return;
        // } else if (accountingDimensions?.dimension4 === "") {
        //   toast.error(`Please enter accouting dimension 4`);
        //   return;
        // } else if (accountingDimensions?.dimension5 === "") {
        //   toast.error(`Please enter accouting dimension 5`);
        //   return;
        // } else if (accountingDimensions?.dimension6 === "") {
        //   toast.error(`Please enter accouting dimension 6`);
        //   return;
        // } else

        if (accountingDimensions?.GLFieldName === "") {
          toast.error(`Please enter gl field name`);
          return;
        } else if (accountingDimensionsFieldName?.Dimension2FieldName === "") {
          toast.error(`Please enter accouting dimension 2 field name`);
          return;
        } else if (accountingDimensionsFieldName?.Dimension3FieldName === "") {
          toast.error(`Please enter accouting dimension field 3 name`);
          return;
        } else if (accountingDimensionsFieldName?.Dimension4FieldName === "") {
          toast.error(`Please enter accouting dimension field 4 name`);
          return;
        } else if (accountingDimensionsFieldName?.Dimension5FieldName === "") {
          toast.error(`Please enter accouting dimension field 5 name`);
          return;
        } else if (accountingDimensionsFieldName?.Dimension6FieldName === "") {
          toast.error(`Please enter accouting dimension field 6 name`);
          return;
        }
        data = {
          GLId: glKey.id,
          dimension2: accountingDimensions?.dimension2,
          dimension3: accountingDimensions?.dimension3,
          dimension4: accountingDimensions?.dimension4,
          dimension5: accountingDimensions?.dimension4,
          dimension6: accountingDimensions?.dimension6,
          GLFieldName: accountingDimensionsFieldName?.GLFieldName,
          Dimension2FieldName:
            accountingDimensionsFieldName.Dimension2FieldName,
          Dimension3FieldName:
            accountingDimensionsFieldName.Dimension3FieldName,
          Dimension4FieldName:
            accountingDimensionsFieldName.Dimension4FieldName,
          Dimension5FieldName:
            accountingDimensionsFieldName.Dimension5FieldName,
          Dimension6FieldName:
            accountingDimensionsFieldName.Dimension6FieldName,
          id: id,
        };
      } else if (totalDimantion == 5) {
        // if (accountingDimensions?.dimension2 === "") {
        //   toast.error(`Please enter accouting dimension 2`);
        //   return;
        // } else if (accountingDimensions?.dimension3 === "") {
        //   toast.error(`Please enter accouting dimension 3`);
        //   return;
        // } else if (accountingDimensions?.dimension4 === "") {
        //   toast.error(`Please enter accouting dimension 4`);
        //   return;
        // } else if (accountingDimensions?.dimension5 === "") {
        //   toast.error(`Please enter accouting dimension 5`);
        //   return;
        // } else if (accountingDimensions?.GLFieldName === "") {
        //   toast.error(`Please enter gl field name`);
        //   return;
        if (accountingDimensions?.Dimension2FieldName === "") {
          toast.error(`Please enter accouting dimension 2 field name`);
          return;
        } else if (accountingDimensions?.Dimension3FieldName === "") {
          toast.error(`Please enter accouting dimension field 3 name`);
          return;
        } else if (accountingDimensions?.Dimension4FieldName === "") {
          toast.error(`Please enter accouting dimension field 4 name`);
          return;
        } else if (accountingDimensions?.Dimension5FieldName === "") {
          toast.error(`Please enter accouting dimension field 5 name`);
          return;
        }

        data = {
          GLId: glKey.id,
          dimension2: accountingDimensions?.dimension2,
          dimension3: accountingDimensions?.dimension3,
          dimension4: accountingDimensions?.dimension4,
          dimension5: accountingDimensions?.dimension4,
          // dimension6: accountingDimensions?.dimension6,
          GLFieldName: accountingDimensionsFieldName?.GLFieldName,
          Dimension2FieldName:
            accountingDimensionsFieldName.Dimension2FieldName,
          Dimension3FieldName:
            accountingDimensionsFieldName.Dimension3FieldName,
          Dimension4FieldName:
            accountingDimensionsFieldName.Dimension4FieldName,
          Dimension5FieldName:
            accountingDimensionsFieldName.Dimension5FieldName,
          // Dimension6FieldName: accountingDimensionsFieldName.Dimension6FieldName,
          id: id,
        };
      } else if (totalDimantion == 4) {
        // if (accountingDimensions?.dimension2 === "") {
        //   toast.error(`Please enter accouting dimension 2`);
        //   return;
        // } else if (accountingDimensions?.dimension3 === "") {
        //   toast.error(`Please enter accouting dimension 3`);
        //   return;
        // } else if (accountingDimensions?.dimension4 === "") {
        //   toast.error(`Please enter accouting dimension 4`);
        //   return;
        // } else if (accountingDimensions?.GLFieldName === "") {
        //   toast.error(`Please enter gl field name`);
        //   return;
        if (accountingDimensions?.Dimension2FieldName === "") {
          toast.error(`Please enter accouting dimension 2 field name`);
          return;
        } else if (accountingDimensions?.Dimension3FieldName === "") {
          toast.error(`Please enter accouting dimension field 3 name`);
          return;
        } else if (accountingDimensions?.Dimension4FieldName === "") {
          toast.error(`Please enter accouting dimension field 4 name`);
          return;
        }
        data = {
          GLId: glKey.id,
          dimension2: accountingDimensions?.dimension2,
          dimension3: accountingDimensions?.dimension3,
          dimension4: accountingDimensions?.dimension4,
          // dimension5: accountingDimensions?.dimension4,
          // dimension6: accountingDimensions?.dimension6,
          GLFieldName: accountingDimensionsFieldName?.GLFieldName,
          Dimension2FieldName:
            accountingDimensionsFieldName.Dimension2FieldName,
          Dimension3FieldName:
            accountingDimensionsFieldName.Dimension3FieldName,
          Dimension4FieldName:
            accountingDimensionsFieldName.Dimension4FieldName,
          // Dimension5FieldName: accountingDimensionsFieldName.Dimension5FieldName,
          // Dimension6FieldName: accountingDimensionsFieldName.Dimension6FieldName,
          id: id,
        };
      } else if (totalDimantion == 3) {
        // if (accountingDimensions?.dimension2 === "") {
        //   toast.error(`Please enter accouting dimension 2`);
        //   return;
        // } else if (accountingDimensions?.dimension3 === "") {
        //   toast.error(`Please enter accouting dimension 3`);
        //   return;
        // } else if (accountingDimensions?.GLFieldName === "") {
        //   toast.error(`Please enter gl field name`);
        //   return;
        if (accountingDimensions?.Dimension2FieldName === "") {
          toast.error(`Please enter accouting dimension 2 field name`);
          return;
        } else if (accountingDimensions?.Dimension3FieldName === "") {
          toast.error(`Please enter accouting dimension field 3 name`);
          return;
        }
        data = {
          GLId: glKey.id,
          dimension2: accountingDimensions?.dimension2,
          dimension3: accountingDimensions?.dimension3,
          // dimension4: accountingDimensions?.dimension4,
          // dimension5: accountingDimensions?.dimension4,
          // dimension6: accountingDimensions?.dimension6,
          GLFieldName: accountingDimensionsFieldName?.GLFieldName,
          Dimension2FieldName:
            accountingDimensionsFieldName.Dimension2FieldName,
          Dimension3FieldName:
            accountingDimensionsFieldName.Dimension3FieldName,
          // Dimension4FieldName: accountingDimensionsFieldName.Dimension4FieldName,
          // Dimension5FieldName: accountingDimensionsFieldName.Dimension5FieldName,
          // Dimension6FieldName: accountingDimensionsFieldName.Dimension6FieldName,
          id: id,
        };
      } else if (totalDimantion == 2) {
        // if (accountingDimensions?.dimension2 === "") {
        //   toast.error(`Please enter accouting dimension 2`);
        //   return;
        // } else if (accountingDimensions?.GLFieldName === "") {
        //   toast.error(`Please enter gl field name`);
        //   return;
        if (accountingDimensions?.Dimension2FieldName === "") {
          toast.error(`Please enter accouting dimension 2 field name`);
          return;
        }
        data = {
          GLId: glKey.id,
          dimension2: accountingDimensions?.dimension2,
          // dimension3: accountingDimensions?.dimension3,
          // dimension4: accountingDimensions?.dimension4,
          // dimension5: accountingDimensions?.dimension4,
          // dimension6: accountingDimensions?.dimension6,
          GLFieldName: accountingDimensionsFieldName?.GLFieldName,
          Dimension2FieldName:
            accountingDimensionsFieldName.Dimension2FieldName,
          // Dimension3FieldName: accountingDimensionsFieldName.Dimension3FieldName,
          // Dimension4FieldName: accountingDimensionsFieldName.Dimension4FieldName,
          // Dimension5FieldName: accountingDimensionsFieldName.Dimension5FieldName,
          // Dimension6FieldName: accountingDimensionsFieldName.Dimension6FieldName,
          id: id,
        };
      }
      ////  console.log(totalDimantion,"totalDimantion")
      addEditAccountDimension(data, (res) => {
        toast.success(res.message);
      });
    } catch (error) {
    //  console.log(error);
    }
  };
//  console.log("accountingDimensionsFieldName", accountingDimensionsFieldName);
  return (
    <div className="container-fluid">
      <div className="dbMain accountDimenbg">
        <Leftpanel />
        <div className="dbRight">
          <Header
            link="/dashboard"
            title={`${t("configuration")} > Others > ${t(
              "accounting_dimensions"
            )}`}
            description=""
          />
          <div className="commonBase">
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="AccountingDimensions">
                    {t("accounting_dimensions")}
                  </label>
                  <select
                    className="form-control"
                    id="AccountingDimensions"
                    name="businessunit"
                    onChange={(e) => _UPDATE_DIMANTION(e.target.value)}
                  >
                    {/* <option value="">Select Accounting Dimensions</option> */}
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={6} selected>
                      6
                    </option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="glKey">{t("gl_key")}</label>
                  <input
                    className="form-control"
                    type="text"
                    id="glKey"
                    placeholder={t("gl_key") + " Field Name"}
                    onChange={(e) =>
                      setAccountingDimensionsFieldName({
                        ...accountingDimensionsFieldName,
                        GLFieldName: e.target.value,
                      })
                    }
                    value={accountingDimensionsFieldName.GLFieldName}
                  />
                  <br />
                </div>
              </div>

              {totalDimantion >= 2 && (
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label htmlFor="glKey">{t("dimension")} 2</label>
                    <input
                      className="form-control"
                      type="text"
                      name="Dimension2FieldName"
                      id="glKey"
                      placeholder="GL Key Field Name"
                      onChange={(e) =>
                        setAccountingDimensionsFieldName({
                          ...accountingDimensionsFieldName,
                          Dimension2FieldName: e.target.value,
                        })
                      }
                      value={accountingDimensionsFieldName.Dimension2FieldName}
                    />
                    <br />
                  </div>
                </div>
              )}
              {totalDimantion >= 3 && (
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label htmlFor="glKey">{t("dimension")} 3</label>
                    <input
                      className="form-control"
                      type="text"
                      id="glKey"
                      placeholder="GL Key Field Name"
                      onChange={(e) =>
                        setAccountingDimensionsFieldName({
                          ...accountingDimensionsFieldName,
                          Dimension3FieldName: e.target.value,
                        })
                      }
                      value={accountingDimensionsFieldName.Dimension3FieldName}
                    />
                    <br />
                  </div>
                </div>
              )}
              {totalDimantion >= 4 && (
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label htmlFor="glKey">{t("dimension")} 4</label>
                    <input
                      className="form-control"
                      type="text"
                      id="glKey"
                      placeholder="GL Key Field Name"
                      onChange={(e) =>
                        setAccountingDimensionsFieldName({
                          ...accountingDimensionsFieldName,
                          Dimension4FieldName: e.target.value,
                        })
                      }
                      value={accountingDimensionsFieldName.Dimension4FieldName}
                    />
                    <br />
                  </div>
                </div>
              )}
              {totalDimantion >= 5 && (
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label htmlFor="glKey">{t("dimension")} 5</label>
                    <input
                      className="form-control"
                      type="text"
                      id="glKey"
                      placeholder="GL Key Field Name"
                      onChange={(e) =>
                        setAccountingDimensionsFieldName({
                          ...accountingDimensionsFieldName,
                          Dimension5FieldName: e.target.value,
                        })
                      }
                      value={accountingDimensionsFieldName.Dimension5FieldName}
                    />
                    <br />
                  </div>
                </div>
              )}
              {totalDimantion >= 6 && (
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label htmlFor="glKey">{t("dimension")} 6</label>
                    <input
                      className="form-control"
                      type="text"
                      id="glKey"
                      placeholder="GL Key Field Name"
                      onChange={(e) =>
                        setAccountingDimensionsFieldName({
                          ...accountingDimensionsFieldName,
                          Dimension6FieldName: e.target.value,
                        })
                      }
                      value={accountingDimensionsFieldName.Dimension6FieldName}
                    />
                    <br />
                  </div>
                </div>
              )}
              {!glKey && (
                <p className="text-center text-danger">{t("update_gl_key")}</p>
              )}
              <button className="commonButton" onClick={_ADD_GL_KEY}>
                {t("save")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAccountingDimensions;
